<template>
  <tf-table-parent-row
    :key="contact.id"
    v-test:tr="contact.id"
  >
    <tf-table-td>
      {{ contact.name }}
    </tf-table-td>
    <tf-table-td>
      <div class="email-address">
        <span :title="contact.email_address">{{ contact.email_address }}</span>
        <tf-button
          v-if="canDelete"
          v-test:button="'delete contact'"
          type="decline"
          icon="trash-alt"
          size="icon-no-fill"
          no-border
          @click="showConfirmationCloseModal = true"
        />
      </div>
    </tf-table-td>
    <modal-notify
      :append-to-body="true"
      :visible.sync="showConfirmationCloseModal"
      custom-image="iconUsersSlash"
      type="warn"
      @close="showConfirmationCloseModal = false"
    >
      <img
        slot="customImage"
        :src="iconUsersSlash"
      >
      <template #title>
        Remove {{ contact.name }} as contact?
      </template>
      <p>This action will remove the carrier service contact for this current coverage.</p>
      <tf-button
        slot="cta"
        v-test:button="'cancel remove contact'"
        class="cancel-close"
        size="large"
        type="secondary"
        no-branding
        @click="showConfirmationCloseModal = false"
      >
        Cancel
      </tf-button>
      <tf-button
        slot="cta"
        v-test:button="'confirm remove contact'"
        size="large"
        type="decline"
        no-branding
        @click="deleteContact()"
      >
        Confirm
      </tf-button>
    </modal-notify>
  </tf-table-parent-row>
</template>

<script>
  import iconUsersSlash from '@/assets/users-slash.svg';
  import { patchEmployerRemoveServiceContact } from '@/services/employer';

  /**
   * The ContactsTableRow component relies on prop data to display an individual
   * service contact's name and an delete icon tf-button that will emit upwards
   * when used.
   *
   * @vuedoc
   * @exports ContactsTableRow
   * @category Components
   */
  export default {
    name: 'ContactsTableRow',
    components: {
      ModalNotify: () => import('@/components/Modals/Notify'),
    },
    props: {
      /**
       * A single contact to be populated in the contact table row.
       */
      contact: {
        type: Object,
        required: true,
      },
      canDelete: {
        type: Boolean,
        default: true,
      },
      clientId: {
        type: [String, Number],
        required: true,
      },
    },
    data: () => ({
      showConfirmationCloseModal: false,
      iconUsersSlash,
    }),
    methods: {
      /**
       * Delete this contact and toast (message dependent on success/fail) and close the modal.
       */
      async deleteContact() {
        try {
          await patchEmployerRemoveServiceContact(this.clientId, this.contact.id);

          this.$emit('deleteContact', this.contact.id);
          this.$message({
            duration: 3000,
            message: 'Service contact removed from this employer.',
            showClose: true,
            type: 'success',
          });
        } catch {
          this.$message({
            duration: 3000,
            message: `There was an error deleting user ${this.contact.name}.`,
            showClose: true,
            type: 'error',
          });
        } finally {
          this.showConfirmationCloseModal = false;
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .email-address {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  span {
    width: 185px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
</style>
